import React from 'react';
import useHelpDeskTicketStatusActions from '../../hooks/useHelpDeskTicketStatusActions';
import HelpDeskTicketActionsDropdown from '../HelpDeskTicketActionsDropdown';
import HelpDeskTicketActionsModals from '../HelpDeskTicketActionsModals';

const TicketListItemActions = ({ ticket, accountId, unreadCount, isManuallyUnread, className, onOpenChange }) => {
  const {
    isClosed,
    isLoading,
    resolutionTimeoutHours,
    showCloseConfirm,
    setShowCloseConfirm,
    showResolveConfirm,
    setShowResolveConfirm,
    isMenuCustomPickerVisible,
    setIsMenuCustomPickerVisible,
    handleResolve,
    handleResolveConfirm,
    handleSnooze,
    handleUnsnooze,
    handleUnresolve,
    handleClose,
    handleReopen,
    handleCloseTicketRequest,
    handleTogglePending,
    isUnread,
    handleToggleRead
  } = useHelpDeskTicketStatusActions({ ticket, accountId, unreadCount, isManuallyUnread });

  return (
    <>
      <HelpDeskTicketActionsDropdown
        className={className}
        ticket={ticket}
        isLoading={isLoading}
        isMenuCustomPickerVisible={isMenuCustomPickerVisible}
        onCustomPickerVisibleChange={setIsMenuCustomPickerVisible}
        onResolve={handleResolve}
        resolveDisabled={isLoading || isClosed}
        onSnooze={handleSnooze}
        onUnsnooze={handleUnsnooze}
        onUnresolve={handleUnresolve}
        onReopen={handleReopen}
        onCloseTicketRequest={handleCloseTicketRequest}
        onTogglePending={handleTogglePending}
        isUnread={isUnread}
        onToggleRead={handleToggleRead}
        onOpenChange={onOpenChange}
        triggerHasBackground
        dataTestId="ticket-list-item-actions-menu"
        isListItemActions
      />

      <HelpDeskTicketActionsModals
        showCloseConfirm={showCloseConfirm}
        onCloseConfirmDismiss={() => setShowCloseConfirm(false)}
        onCloseConfirm={handleClose}
        showResolveConfirm={showResolveConfirm}
        onResolveConfirmDismiss={() => setShowResolveConfirm(false)}
        onResolveConfirm={handleResolveConfirm}
        resolutionTimeoutHours={resolutionTimeoutHours}
      />
    </>
  );
};

export default TicketListItemActions;
